import { Form, InputGroup } from "react-bootstrap";
import ColorChip from "./ColorChip";

export default function ColorInput({ value, onChange }) {
    return <InputGroup>
        <Form.Control type="text" placeholder="Enter color" aria-label="Color Input" required value={value} onChange={onChange} />
        <InputGroup.Text><ColorChip key={Math.random()} color={value} /></InputGroup.Text>
    </InputGroup>;
}